if (!customElements.get('trust-indicators-slider')) {
  class TrustIndicatorsSlider extends HTMLElement {
    constructor() {
      super();
      this.slider = null;
    }

    connectedCallback() {
      const swiperOptions = JSON.parse(this.getAttribute('data-swiper-options')) || {};

      // Initial load
      this.initSlider(swiperOptions);

      // Shopify theme editor reload fix
      if (Shopify.designMode) {
        window.addEventListener('shopify:section:load', () => {
          this.initSlider(swiperOptions);
        });
      }
    }

    initSlider(swiperOptions) {
      // Destroy existing instance (important for re-init)
      if (this.slider) {
        this.slider.destroy(true, true);
        this.slider = null;
      }

      const loop = swiperOptions.loop || false;
      const autoplay = swiperOptions.autoplay || false;

      this.slider = new Swiper(this, {
        slidesPerView: 1,
        loop: loop,

        pagination: {
          el: '.trust-indicators--progressbar',
          type: 'progressbar',
        },

        navigation: {
          nextEl: '.trust-carousel__control-next',
          prevEl: '.trust-carousel__control-prev',
        },

        autoplay: autoplay,

        spaceBetween: swiperOptions.spaceBetweenMobile || 2,

        breakpoints: {
          750: {
            spaceBetween: swiperOptions.spaceBetweenDesktop || 2,
            slidesPerView: 2,
            loop: loop,
          },
          990: {
            spaceBetween: swiperOptions.spaceBetweenDesktop || 0,
            slidesPerView: swiperOptions.slidesPerView || 2,
            loop: loop,
          }
        }
      });
    }
  }

  customElements.define('trust-indicators-slider', TrustIndicatorsSlider);
}